export const MERCHANT_ADMIN_SETTINGS = {
    OPTIONAL_SETUP_STEP: "optional-setup-step",
    REQUIRED_SETUP_STEP: "required-setup-step",
};
